import _Reflect$construct from "@babel/runtime-corejs2/core-js/reflect/construct";
import _extends from "@babel/runtime-corejs2/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import NavDropdown from './NavDropdown';
import NavSearch from './NavSearch';
import Sidebar from './Sidebar';
import Header from './Header';

var Nav = /*#__PURE__*/function (_React$Component) {
  _inherits(Nav, _React$Component);

  var _super = _createSuper(Nav);

  function Nav() {
    _classCallCheck(this, Nav);

    return _super.apply(this, arguments);
  }

  _createClass(Nav, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          horizontal = _this$props.horizontal,
          vertical = _this$props.vertical,
          forwardedRef = _this$props.forwardedRef,
          props = _objectWithoutProperties(_this$props, ["horizontal", "vertical", "forwardedRef"]);

      var NavComponent = vertical ? Sidebar : Header;
      return /*#__PURE__*/React.createElement(NavComponent, _extends({}, props, {
        ref: forwardedRef
      }));
    }
  }]);

  return Nav;
}(React.Component);

_defineProperty(Nav, "Dropdown", NavDropdown);

_defineProperty(Nav, "Search", NavSearch);

var NavWrapper = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Nav, _extends({
    forwardedRef: ref
  }, props));
});
NavWrapper.Dropdown = NavDropdown;
NavWrapper.Search = NavSearch;
export default NavWrapper;